import { Button, Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { type ShortcutNavInterface } from "@/components/app/scaffoldReducer";
import TTButton from "@/containers/buttons/TTButton";

export default function ShortcutsArea({ shortcuts }: { shortcuts: ShortcutNavInterface[] }) {
  const { t } = useTranslation(["translation"]);
  const items = shortcuts.flatMap((s) => s.items);

  if (items.length === 0) return null;

  const promoted = items.filter((i) => i.promoted);
  const rest = items.filter((i) => !i.promoted);

  if (promoted.length === 0 && rest.length === 1) {
    const item = rest[0];
    return item.to ? (
      <TTButton as={Link} to={item.to} variant="outline-secondary" size="sm">
        {item.label}
      </TTButton>
    ) : (
      <Button variant="outline-secondary" size="sm" onClick={item.onClick}>
        {item.label}
      </Button>
    );
  }

  return (
    <>
      {promoted.map((item) => {
        const Icon = item.icon;
        const content = (
          <>
            {Icon && <Icon size="1rem" />}
            {item.label}
          </>
        );
        return item.to ? (
          <TTButton
            key={item.id}
            as={Link}
            to={item.to}
            variant="outline-secondary"
            size="sm"
            className="TT-shortcuts-promoted"
          >
            {content}
          </TTButton>
        ) : (
          <Button
            key={item.id}
            variant="outline-secondary"
            size="sm"
            className="TT-shortcuts-promoted"
            onClick={item.onClick}
          >
            {content}
          </Button>
        );
      })}

      {rest.length > 0 && (
        <Dropdown align="end">
          <Dropdown.Toggle variant="outline-secondary" size="sm">
            {t("translation:global.actions")}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {rest.map((item) =>
              item.to ? (
                <Dropdown.Item key={item.id} as={Link} to={item.to}>
                  {item.label}
                </Dropdown.Item>
              ) : (
                <Dropdown.Item key={item.id} onClick={item.onClick}>
                  {item.label}
                </Dropdown.Item>
              ),
            )}
          </Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
}
